interface CustomWindow extends Window {
  _hsq: any[];
}

declare let window: CustomWindow;

window._hsq = window._hsq || []; //this is the global Hubspot object
export default window;
